"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = FlatsomeInitializer;
var jsx_runtime_1 = require("react/jsx-runtime");
//@ts-ignore
var flatsomeProps_1 = require("../../../lib/head/js/client/flatsomeProps");
function FlatsomeInitializer() {
    return ((0, jsx_runtime_1.jsx)("script", { id: "flatsome-js-js-extra", crossOrigin: "anonymous", dangerouslySetInnerHTML: {
            __html: "window.flatsomeVars = ".concat(JSON.stringify(flatsomeProps_1.default), ";"),
        } }));
}
